import React from 'react';
import Layout from '../layouts/claire';
import { Link } from 'react-router';
import { Animated } from 'react-animated-css';
import config from '../../config';
import Menu from '../partials/menu';
import TopRightMenu from '../partials/top_right_menu';
import fakeAuth from '../../fakeAuth';
import moment from 'moment';
import LineLoader from '../partials/line_loader';
import _ from 'lodash';

const REPORT_CARDS = [
    {
        key: 'occupation',
        path: 'occupation',
        icon: 'fas fa-percent',
        title: 'Ocupación y Saldos',
        description: 'Habitaciones ocupadas, balances y datos de huéspedes activos.',
        color: '#00C6FE',
    },
    {
        key: 'forecast',
        path: 'forecast',
        icon: 'fas fa-chart-line',
        title: 'Forecast',
        description: 'Proyección de entradas, salidas y ocupación por día.',
        color: '#6E44FF',
    },
    {
        key: 'guests',
        path: 'guests',
        icon: 'fas fa-id-card',
        title: 'Huéspedes',
        description: 'Libro de huéspedes con datos de identidad y estadía.',
        color: '#00c97a',
    },
    {
        key: 'close',
        path: 'close',
        icon: 'fas fa-cash-register',
        title: 'Cierre',
        description: 'Reporte de cierre diario por empleado y forma de pago.',
        color: '#FFC107',
    },
    {
        key: 'transactions',
        path: 'transactions',
        icon: 'fas fa-exchange-alt',
        title: 'Transacciones',
        description: 'Historial completo de movimientos contables del día.',
        color: '#FF6B6B',
    },
    {
        key: 'charges',
        path: 'charges',
        icon: 'fas fa-file-invoice-dollar',
        title: 'Cargos',
        description: 'Cargos realizados por día, habitación, concepto y empleado.',
        color: '#FF9F43',
    },
];

class Reports extends React.Component {
    state = {
        hotel_name: localStorage.getItem('lb.ip') ? JSON.parse(localStorage.getItem('lb.ip')).Name : null,
    }

    componentWillMount() {
        this.props.logic_actions?.fetch_conversion_rates();
    }

    renderHeader = () => (
        <div className="d-flex">
            <div className="w-100 d-flex">
                <i className="icon-lb_reportes blue font-40 align-self-center" />
                <div className="align-self-center d-flex flex-column">
                    <span className="white ms-3 font-20 line1 poppins">Reportes</span>
                    <Link to="/properties" className="white ms-3 font-10 poppins underlined">{this.state.hotel_name}</Link>
                </div>
            </div>
            <div className="w-100 d-flex align-self-center">
                <TopRightMenu {...this.props} />
            </div>
        </div>
    )

    renderCommon = () => {
        const { params } = this.props;
        return (
            <div>
                {this.renderHeader()}

                <div className="mt-2 mb-3">
                    <span className="gray font-12 poppins">{moment().locale('es').format('dddd, D [de] MMMM [de] YYYY')}</span>
                </div>

                <Animated animationIn="fadeInUp" animationInDuration={300} className="d-flex flex-wrap" style={{ gap: 16, maxWidth: 900 }}>
                    {REPORT_CARDS.map((card) => (
                        <Link
                            key={card.key}
                            to={`/reports/${card.path}/${params.id}`}
                            className="d-flex flex-column bg-gray-2"
                            style={{
                                borderRadius: 10,
                                width: 260,
                                padding: '20px 20px',
                                textDecoration: 'none',
                                borderLeft: `3px solid ${card.color}`,
                                transition: 'background .15s',
                            }}
                        >
                            <div className="d-flex align-items-center mb-2">
                                <div
                                    className="d-flex align-items-center justify-content-center"
                                    style={{
                                        width: 38, height: 38, borderRadius: 8,
                                        background: `${card.color}22`,
                                    }}
                                >
                                    <i className={`${card.icon} font-16`} style={{ color: card.color }} />
                                </div>
                                <span className="white poppins font-14 ms-2" style={{ fontWeight: 600 }}>{card.title}</span>
                            </div>
                            <span className="gray font-11 poppins" style={{ lineHeight: 1.5 }}>{card.description}</span>
                            <div className="d-flex align-items-center mt-3">
                                <span className="font-11 poppins" style={{ color: card.color }}>Ver reporte</span>
                                <i className="fas fa-arrow-right ms-2 font-10" style={{ color: card.color }} />
                            </div>
                        </Link>
                    ))}
                </Animated>
            </div>
        );
    }

    render() {
        return (
            <Layout router={this.props.router} nbs="home" title="legendbeds" form={this.props.form} form_actions={this.props.form_actions}>
                <section>
                    {this.state.microTransac && <LineLoader />}

                    {/* DESKTOP */}
                    <div className="w3-container w3-hide-small" style={{ marginLeft: 100 }}>
                        <div style={{ height: 50 }} />
                        {this.renderCommon()}
                    </div>

                    <Menu {...this.state} {...this.props} />
                </section>
            </Layout>
        );
    }
}

export default Reports;
